"use client";

import React from "react";
import { Minus, Plus } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How does FocusPath leverage Global 500 experience for SMEs?",
  answer: "We apply the same rigorous methodologies and efficiency frameworks used by the world's largest corporations, scaled specifically for the agility and unique resource constraints of small to medium-sized businesses."
}, {
  question: "What types of AI and agentic solutions do you implement?",
  answer: "We specialize in agentic AI and intelligent process automation. Our focus is on deploying tools that reduce manual overhead, enhance executive decision-making, and integrate seamlessly with your existing business tech stack."
}, {
  question: "How long does a typical consulting engagement last?",
  answer: "Our transformation projects typically range from 3 to 6 months. This starts with a rapid 4-week diagnostic phase, followed by phased implementation and comprehensive employee change management to ensure adoption."
}, {
  question: "Do we need an internal technical team to work with you?",
  answer: "Not necessarily. We act as your strategic technology partner. We can guide your existing team, or if you don't have one, we help you identify and train the right internal resources to maintain your new AI-driven systems."
}, {
  question: "How do you measure the success of an AI integration?",
  answer: "Success is defined by quantifiable KPIs established at kickoff: significant reduction in process cycle times, measurable cost savings from automation, and improved data accuracy across your core operations."
}];
export default function EngagementFaq() {
  return <section data-section-id="111296" id="common-inquiries" className="bg-background text-foreground py-24 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-[700px]">
        <div className="mb-16 text-center">
          <h2 className="font-sans text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-primary">
            Common Inquiries
          </h2>
          <p className="font-sans text-slate-600 text-lg max-w-lg mx-auto">
            Answers to frequently asked questions about our AI-driven consulting and process optimization services.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-slate-200 py-2 data-[state=open]:bg-blue-50/40 transition-colors duration-300 rounded-lg px-4">
              <AccordionTrigger className="font-sans text-xl md:text-2xl font-bold hover:no-underline [&>svg]:hidden group text-left py-6">
                <span className="flex-1 pr-8 text-slate-900 group-hover:text-secondary transition-colors">
                  {faq.question}
                </span>
                <span className="relative flex size-6 items-center justify-center shrink-0 text-slate-400 group-hover:text-secondary transition-colors">
                  <Plus className="absolute size-5 transition-all duration-300 group-data-[state=open]:opacity-0 group-data-[state=open]:rotate-90" strokeWidth={2} />
                  <Minus className="absolute size-5 transition-all duration-300 opacity-0 -rotate-90 group-data-[state=open]:opacity-100 group-data-[state=open]:rotate-0" strokeWidth={2} />
                </span>
              </AccordionTrigger>
              <AccordionContent className="font-sans text-slate-600 text-base md:text-lg leading-relaxed pt-2 pb-8 pr-12">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}